module.exports = __webpack_public_path__ + "img/learnByPlay.1ed34ea8.jpeg";